<!--suppress HtmlUnknownTag -->
<vuejs3-todo>
    Ready
</vuejs3-todo>

<template>
    <section class="compatibility-page">
        <h1>
            <template v-if="$i18n.lang === 'fr'">Votre navigateur est obsolète...</template>
            <template v-else-if="$i18n.lang === 'de'">Ihr Browser ist veraltet...</template>
            <template v-else>Your browser is obsolete...</template>
        </h1>
        <div>
            <template v-if="$i18n.lang === 'fr'">
                Afin de vous assurer la meilleure expérience possible lorsque vous utilisez l'application Echoline, nous
                assurons le support de tous les navigateurs "modernes", dont Chrome (Google), Firefox (Mozilla), Safari
                (Apple - disponible seulement sur macOS, iOS et iPadOS) et Edge (Microsoft - v79+). Tous les navigateurs
                basés sur le projet Chromium sont également supportés.
            </template>
            <template v-else-if="$i18n.lang === 'de'">
                Wir möchten Ihnen eine optimale Benutzererfahrung beim Einsatz der Echoline-Anwendung bieten, deswegen
                stellen wir den Support für alle aktuellen Browser sicher, darunter Chrome (Google), Firefox (Mozilla),
                Safari (Apple - nur für macOS, iOS und iPadOS) sowie Edge (Microsoft - v79+) verfügbar. Alle Browser,
                die auf dem Chromium-Projekt beruhen, werden ebenso unterstützt.
            </template>
            <template v-else>
                To ensure you have a great experience using Echoline application, we support all "modern" web browsers,
                including Chrome (Google), Firefox (Mozilla), Safari (Apple - available on macOS, iOS and iPadOS only)
                and Edge (Microsoft - v79+). All web browsers based on Chromium project are also supported.
            </template>
        </div>
        <p>
            <template v-if="$i18n.lang === 'fr'">
                Mettez à jour votre navigateur pour plus de sécurité et de confort :
                <a href="https://www.browsehappy.com/" target="_blank">www.browsehappy.com</a> -
                <a href="https://www.echoline.fr/" target="_blank">www.echoline.fr</a>
            </template>
            <template v-else-if="$i18n.lang === 'de'">
                Aktualisieren Sie ihren Browser und kommen Sie in den Genuss von mehr Sicherheit und Ergonomie:
                <a href="https://www.browsehappy.com/" target="_blank">www.browsehappy.com</a> -
                <a href="https://www.echoline.fr/" target="_blank">www.echoline.fr</a>
            </template>
            <template v-else>
                Update your web browser for more security and confort:
                <a href="https://www.browsehappy.com/" target="_blank">www.browsehappy.com</a> -
                <a href="https://www.echoline.fr/" target="_blank">www.echoline.fr</a>
            </template>
        </p>
    </section>
</template>

<script>
    export default {
        name: "CompatibilityPage"
    }
</script>

<style lang="scss">
    @import "../../colors";
    @import "../../variables";

    .compatibility-page {
        display: flex;
        height: 100vh;
        width: 100vw;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        background-image: url("/img/outside_compatibility-page_background.svg");
        background-position: bottom right;
        background-repeat: no-repeat;
        background-size: 32%;

        h1 {
            margin: 16px 0;
            font-weight: $font-weight-bold;
        }

        div {
            background-color: $color-backdrop;
            color: white;
            width: 40%;
            margin: 0 auto;
            box-sizing: border-box;
            padding: 16px;
            border-radius: 8px;
            text-align: center;
        }

        p {
            margin: 16px 0;
        }
    }
</style>
